import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { useLang } from "../lib/lang";
import { Reveal } from "./Motion";

export default function CtaBand() {
  const { t } = useLang();
  return (
    <section className="px-5 py-20 sm:py-24">
      <Reveal>
        <div className="relative mx-auto max-w-6xl overflow-hidden rounded-[2.5rem] bg-saffron px-8 py-16 text-center sm:px-16" data-testid="cta-band">
          <span aria-hidden="true" className="pointer-events-none absolute -right-6 -top-10 select-none font-display text-[11rem] leading-none text-[#FDFBF7]/15">
            अ
          </span>
          <span aria-hidden="true" className="pointer-events-none absolute -bottom-12 -left-4 select-none font-display text-[10rem] leading-none text-[#1E1B4B]/10">
            आ
          </span>
          <h2 className="relative font-display text-3xl text-[#FDFBF7] sm:text-4xl lg:text-5xl">{t.ctaBand.title}</h2>
          <p className={`relative mx-auto mt-4 max-w-xl text-base leading-relaxed text-[#FDFBF7]/90 ${""}`}>
            {t.ctaBand.text}
          </p>
          <Link to="/contact" data-testid="cta-band-button" className="relative mt-8 inline-flex items-center gap-2 rounded-full bg-ink px-8 py-4 text-sm font-semibold text-[#FDFBF7] shadow-lg transition-all duration-300 hover:-translate-y-0.5 hover:bg-[#FDFBF7] hover:text-ink">
            {t.ctaBand.button}
            <ArrowRight size={16} />
          </Link>
        </div>
      </Reveal>
    </section>
  );
}
